import React from 'react';
import { Section, SectionHeader, RelatedArticles } from 'components';
import { isEmpty } from 'lodash';

const related = [
  'Visualising Energy',
  'How to scale a monolithic MVP application without losing business?',
  'From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand',
].map(title => ({ title }));

const LearnMore = ({ allArticles }) => (
  <>
    <Section color={'white'} additionalClass={'pdap__learn-more'}>
      <SectionHeader
        size={'medium'}
        description={
          'Discover our articles and insights about digital product design and development shared by our designers, developers and scrum masters.'
        }
        fixed
      >
        Learn more
      </SectionHeader>
    </Section>
    {!(isEmpty(allArticles) || isEmpty(related)) && (
      <RelatedArticles
        id={'pdad-learn-more-articles'}
        related={related}
        background={'white'}
        allArticles={allArticles}
        sectionTitle={false}
        fixed
      />
    )}
  </>
);

export default LearnMore;
